import { jwtDecode } from "jwt-decode";
import Cookies from 'js-cookie';

export const isAuthenticated = () =>
{
    return !!localStorage.getItem("token");
};

export const getUser = () =>
{
    const user = String(jwtDecode(Cookies.get('toksen')).Onboarding).toLowerCase();
    alert(user);
    return user || {};
};